type SortingArrowsProps = {
  sorting?: 'asc' | 'desc' | 'none'
}

const SortingArrows = ({ sorting }: SortingArrowsProps) => {
  const showUp = sorting === 'asc' || sorting === 'none'
  const showDown = sorting === 'desc' || sorting === 'none'

  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 8V19V18.675"
        stroke={showDown ? 'currentColor' : 'lightgray'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 12V1V2.14429"
        stroke={showUp ? 'currentColor' : 'lightgray'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 15.0001L15 18.9998L19 14.9998"
        stroke={showDown ? 'currentColor' : 'lightgray'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1 5.00024L5 1.00024L9 5.00024"
        stroke={showUp ? 'currentColor' : 'lightgray'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default SortingArrows
